<template>
  <div>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="2">
          <v-menu transition="scale-transition" offset-y v-model="dateMenu">
            <template v-slot:activator="{ on }">
              <v-text-field label="Month" hide-details dense readonly v-on="on" v-model="monthAsDate" outlined append-icon="mdi-menu-down" @click:append="dateMenu=true"/>
            </template>
            <v-date-picker v-model="month" type="month" no-title @change="refresh"/>
          </v-menu>
        </v-col>
        <v-col cols="3" class="ml-2">
          <v-select label="Category" v-model="category" :items="['Refreshments','Spirits and Liquers']" outlined dense hide-details  @change="refresh"/>
        </v-col>
        <v-col class="text-right pr-2">
          <v-btn icon @click="print"><v-icon>mdi-printer</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 180px)">
      <div v-html="printReport()"/>
    </v-card>
  </div>
</template>

<script>
import {format,add} from 'date-fns'
import printHtml from '@/mixins/printHtml'

export default {
  name: 'MonhtlyCraftProducerReport',
  mixins: [printHtml],
  data() {
    return {
      dateMenu: false,
      month: '',
      category: 'Spirits and Liquers',
      report: null
    }
  },
  computed: {
    monthAsDate() {
      return this.$formatDate(this.month+'-01', 'MMMM, yyyy');
    },
    company() {
      return this.$store.getters.company;
    }
  },
  async created() {
    this.$emit('name', 'Saskatchewan Monthly Craft Producer Report')
    this.month = format(add(new Date(), {months:-1}), 'yyyy-MM');
    this.refresh();
  },
  methods: {
    async refresh() {
      const results = await this.$apiCall(`query MonhtlyCraftProducerReport($date:Date!, $category:String!) {
                                             skMonthly(date:$date, category:$category) {
                                                line1, line2, line3, line4, line5, line6, line7, line8, line9, line10
                                             }
                                           }`,
                                           {date:`${this.month}-01`, category:this.category});
      if (!results.error)
        this.report = results.data.skMonthly;
    },

    printReport() {
      if (!this.report)
        return '';

      return `<style>
                @page {size:portrait}
                .report {font-family: Roboto, sans-serif; font-size:14px;width:100%;border-spacing:0;border-collapse:collapse}
                .report .title {font-weight:700;font-size:18px;text-align:left}
                .report .sub-title {text-align:left}
                .report tbody {border:2px solid #888}
                .report tbody tr {
                  vertical-align:middle;
                }
                .report tbody td {
                  padding:8px;
                  border:1px solid #888;
                  font-style: italic;
                }
                .report td:nth-child(1) {
                  width:10%;
                }
                .report td:nth-child(2) {
                  width:55%;
                }
                .report td:nth-child(3) {
                  width:25%;
                  font-style: normal;
                  font-size:110%
                }
                .report td:nth-child(4) {
                  width:10%;
                }
                .details {
                  font-size:80%
                }
                .total {
                  font-weight:bold;
                }
              </style>
              <table class="report">
                <thead>
                  <tr>
                    <th colspan="4" class="title">Saskatchewan Monthly Craft Producer Report</th>
                  </tr>
                  <tr>
                    <th colspan="4" class="sub-title">${this.monthAsDate}</th>
                  </tr>
                  <tr><th colspan="4">&nbsp;</</th></tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Line 1</td>
                    <td>Inventory carried forward from the previous month</td>
                    <td>${this.$number(this.report.line1)}</td>
                    <td>litres</td>
                  </tr>
                  <tr>
                    <td>Line 2</td>
                    <td>Monthly production</td>
                    <td>${this.$number(this.report.line2)}</td>
                    <td>litres</td>
                  </tr>
                  <tr>
                    <td>Line 3</td>
                    <td>Direct sales and sampling in province</td>
                    <td>${this.$number(this.report.line3)}</td>
                    <td>litres</td>
                  </tr>
                  <tr>
                    <td>Line 4</td>
                    <td>Sales outside of province (including bulk)</td>
                    <td>${this.$number(this.report.line4)}</td>
                    <td>litres</td>
                  </tr>
                  <tr>
                    <td>Line 5</td>
                    <td>Sales to SLGA Distribution Centre and/or 3rd Party Distributor</td>
                    <td>${this.$number(this.report.line5)}</td>
                    <td>litres</td>
                  </tr>
                  <tr>
                    <td>Line 6</td>
                    <td>Product destroyed</td>
                    <td>${this.$number(this.report.line6)}</td>
                    <td>litres</td>
                  </tr>
                  <tr>
                    <td colspan="4" class="details">Details and Reason:</td>
                  </tr>
                  <tr>
                    <td>Line 7</td>
                    <td>Product returned</td>
                    <td>${this.$number(this.report.line7)}</td>
                    <td>litres</td>
                  </tr>
                  <tr>
                    <td colspan="4" class="details">Details and Reason:</td>
                  </tr>
                  <tr>
                    <td>Line 8</td>
                    <td>Other Adjustments</td>
                    <td>${this.$number(this.report.line8)}</td>
                    <td>litres</td>
                  </tr>
                  <tr>
                    <td colspan="4" class="details">Details and Reason:</td>
                  </tr>
                  <tr class="total">
                    <td>Line 9</td>
                    <td>Total product now in inventory</td>
                    <td>${this.$number(this.report.line9)}</td>
                    <td>litres</td>
                  </tr>
                  <tr class="total">
                    <td>Line 10</td>
                    <td>Amount of product used for levy calculation</td>
                    <td>${this.$number(this.report.line10)}</td>
                    <td>litres</td>
                  </tr>
                </tbody>
              </table>`;
    },

    async print() {
      this.printHtml('Monthly Craft Producer Report', this.printReport());
    }
  }
}
</script>